import { motion } from 'framer-motion';
import { NatureEnum } from '../../../../../types/nature';
import { Description } from '../Configurations';
import { useDispatch } from 'react-redux';
import { editField, editQuickAction, editTableColumnSummary } from '../../../store/slice';
import { EntryQuickAction } from '../../../../../types/custom-worksheet-v2';

type PositiveNatureProps = {
    id: string;
    quickAction: EntryQuickAction;
    isSummary: boolean;
};

function PositiveNature({ id, quickAction, isSummary }: PositiveNatureProps): JSX.Element {
    const dispatch = useDispatch();

    function handleUpdateNature(positiveNature: NatureEnum): void {
        dispatch(editQuickAction({ id, type: quickAction.type, payload: { ...quickAction.payload, positiveNature } }));
    }

    return (
        <div className="flex justify-between gap-2">
            <Description title="Positive Nature" description="Configure if positive values are debit or credit." />
            <div className="h-fit flex items-center gap-2 p-1 bg-gray-100 rounded-md">
                {Object.values(NatureEnum)
                    .sort((a, b) => (a > b ? -1 : 1))
                    .map((n) => {
                        const isSelected = quickAction.payload.positiveNature === n;

                        return (
                            <div key={n} className="py-1 px-3 relative" onClick={(): void => handleUpdateNature(n)}>
                                <div className="w-4 h-4 flex justify-center items-center shrink-0">
                                    {isSelected && (
                                        <motion.div
                                            initial={false}
                                            layoutId="entry-nature"
                                            className="w-full h-full rounded-md bg-white absolute left-0"
                                        />
                                    )}
                                    <div
                                        className={`z-10 hover:cursor-pointer hover:text-gray-800 text-sm ${
                                            isSelected ? 'text-gray-800' : 'text-gray-400'
                                        }`}
                                    >
                                        {`${n[0]}r`}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}

export default PositiveNature;
